import {
  Box,
  Button,
  Chip,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import jsPDF from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { FaLink } from "react-icons/fa6";
import { GoArrowUpRight } from "react-icons/go";
import { FaRegBookmark } from "react-icons/fa6";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import statesData from "../../InsocialOrbit/Brand/Campaign/statesData";
import "../Assets/css/influencer.css";
import BackVector from "../Assets/Img/BackVector.svg";
import DownloadCampaign from "../Assets/Img/DownloadCampaign.svg";
import instagram from "../Assets/Img/instagram.png";
import youtube from "../Assets/Img/youtube.png";
import { theme } from "../Common/SetupProfile/constant";
import axiosMain from "../http/axiosMain";
import CollaborationModal from "./CollaborationModal";
import dayjs from "dayjs";
import "bootstrap-icons/font/bootstrap-icons.css";

function InfluencerDetail() {
  const [selectedState, setSelectedState] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedGender, setSelectedGender] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedAge, setSelectedAge] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [timeLine, setTimeLine] = useState([]);
  const [Brand_id, setBrand_id] = useState();
  const [priviewContract, setpriviewContract] = useState(false);
  const [concernMessage, setConcernMessage] = useState("");

  const openPriviewModal = () => setpriviewContract(true);
  const closePriviewModal = () => setpriviewContract(false);
  const MAX_LANGUAGES = 4;

  // Ensure selectedLanguages is an array and map it to their full names
  const selectedLangNames = Array.isArray(selectedLanguages)
    ? selectedLanguages.map((shortName) => {
        const lang = languages.find(
          (language) => language.short_name === shortName
        );
        return lang ? lang.name : shortName;
      })
    : []; // Default to an empty array if selectedLanguages is not an array

  // Check if the number of selected languages exceeds MAX_LANGUAGES
  const showMoreLanguages = selectedLangNames.length > MAX_LANGUAGES;

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const { id } = useParams();
  const navigate = useNavigate();
  const [InfluencerDetailData, setInfluencerDetailData] = useState(null);

  const fetchCampaign = async () => {
    try {
      const response = await axiosMain.get("/api/v1/all", {
        params: {
          campaign_id: id,
        },
      });

      // Log the full response to check the structure
      // console.log("influencer-lang", response.data);
      setBrand_id(response?.data?.campaigns[0]?.user_id);
      localStorage.setItem("Brand_id", response?.data?.campaigns[0]?.user_id);
      setInfluencerDetailData(response.data.campaigns[0]);
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };
  useEffect(() => {
    fetchCampaign();
  }, [id]);

  // console.log("InfluencerDetailData", InfluencerDetailData);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getUTCFullYear();

    const daySuffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month} ${year}`;
  };

  const handleSaveCampaign = async () => {
    try {
      if (!InfluencerDetailData) {
        console.error("Campaign data not available.");
        return;
      }
      const response = await axiosMain.post("/api/v1/save-campaign", {
        campaignId: InfluencerDetailData.campaign_id, // Directly use campaign_id
        action: "save",
      });
      if (response.status == 200) {
        fetchCampaign();
      }
    } catch (error) {
      console.error(
        "Error saving campaign:",
        error.response ? error.response.data : error.message
      );
    }
    fetchCampaign();
  };

  const viewBrandProfile = async () => {
    // try {
    //   const response = await axiosMain.get("/api/v1/get-brand-profile/", {
    //     params: { user_id: Brand_id },
    //   });
    //   // if (response.data?.user?.user_photo) {
    //   console.log("brand details", response.data);

    //   if (response?.data?.user?.user_id) {
    const currentPath = window.location.pathname;
    localStorage.setItem("CampaignById", currentPath);
    //     navigate("/myprofile");
    //   }
    //   // }
    // } catch (error) {
    //   console.error("Error fetching brand profile:", error);
    // }
    navigate("/view-brand-profile");
  };

  // useEffect(() => {
  //   if (Brand_id) {
  //     viewBrandProfile();
  //   }
  // }, [Brand_id]);
  // const pdfRef = useRef();

  const handleDownloadPDF = async () => {
    if (!InfluencerDetailData) return;

    const pdf = new jsPDF("p", "mm", "a4");
    const margin = 10;
    let y = margin;

    // Inline function to convert image URL to base64
    const getBase64ImageFromURL = async (url) => {
      const response = await fetch(url);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    // Add campaign poster image if available
    if (InfluencerDetailData.campaign_poster) {
      try {
        const base64Img = await getBase64ImageFromURL(
          InfluencerDetailData.campaign_poster
        );
        const imgWidth = 180;
        const imgHeight = 100;
        pdf.addImage(base64Img, "JPEG", margin, y, imgWidth, imgHeight);
        y += imgHeight + 8;
      } catch (error) {
        console.error("Image load error:", error);
      }
    }

    // Add campaign text details
    pdf.setFontSize(14);
    pdf.text("Campaign Details", margin, y);
    y += 8;

    pdf.setFontSize(11);
    pdf.text(
      `Title: ${InfluencerDetailData.campaign_title || "N/A"}`,
      margin,
      y
    );
    y += 6;
    pdf.text(
      `Primary Objective: ${
        InfluencerDetailData.campaign_primary_objective || "N/A"
      }`,
      margin,
      y
    );
    y += 6;
    pdf.text(
      `Secondary Objective: ${
        InfluencerDetailData.campaign_secondary_objective || "N/A"
      }`,
      margin,
      y
    );
    y += 6;
    pdf.text(
      `Description: ${InfluencerDetailData.description || "N/A"}`,
      margin,
      y
    );
    y += 6;

    const budgetValue =
      InfluencerDetailData.budget?.replace(/[^\d.-]/g, "") || "0";
    pdf.text(`Budget: ${budgetValue}`, margin, y);
    y += 6;

    pdf.text(
      `Compensation: ${InfluencerDetailData.compensation_type || "N/A"}`,
      margin,
      y
    );
    y += 6;

    const startDate = new Date(
      InfluencerDetailData.start_date
    ).toLocaleDateString();
    const endDate = new Date(
      InfluencerDetailData.end_date
    ).toLocaleDateString();
    pdf.text(`Campaign Duration: ${startDate} to ${endDate}`, margin, y);
    y += 8;

    // Target Audience
    pdf.setFontSize(12);
    pdf.text("Target Audience:", margin, y);
    y += 6;
    pdf.setFontSize(11);
    pdf.text(
      `States: ${InfluencerDetailData.state?.join(", ") || "N/A"}`,
      margin,
      y
    );
    y += 6;
    pdf.text(
      `Cities: ${InfluencerDetailData.city?.join(", ") || "N/A"}`,
      margin,
      y
    );
    y += 6;
    pdf.text(
      `Gender: ${InfluencerDetailData.gender?.join(", ") || "N/A"}`,
      margin,
      y
    );
    y += 6;
    pdf.text(
      `Age Group: ${InfluencerDetailData.age_group?.join(", ") || "N/A"}`,
      margin,
      y
    );
    y += 6;

    const languages =
      InfluencerDetailData.language?.map((lang) => lang.name).join(", ") ||
      "N/A";
    pdf.text(`Languages: ${languages}`, margin, y);
    y += 8;

    // Timeline Deliverables
    pdf.setFontSize(12);
    pdf.text("Timeline Deliverables:", margin, y);
    y += 6;
    pdf.setFontSize(11);

    InfluencerDetailData.timeline?.forEach((weekObj) => {
      pdf.text(`Week ${weekObj.week}:`, margin, y);
      y += 6;
      if (weekObj.YouTube) {
        const yt = weekObj.YouTube;
        pdf.text(
          `  YouTube - Shorts: ${yt.shorts}, Videos: ${yt.videos}, Live: ${yt.live_stream}`,
          margin,
          y
        );
        y += 5;
      }
      if (weekObj.Instagram) {
        const ig = weekObj.Instagram;
        pdf.text(
          `  Instagram - Posts: ${ig.posts}, Reels: ${ig.reels}, Stories: ${ig.story}`,
          margin,
          y
        );
        y += 6;
      }
    });

    // Save the PDF
    pdf.save("CampaignDetails.pdf");
  };
  const formatDeliverableName = (name) => {
    return name
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [contractFile, setContractFile] = useState(null);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleUpload = async () => {
    if (!contractFile) {
      alert("Please upload a PDF contract file.");
      return;
    }

    const formData = new FormData();
    formData.append("contract_status", "Accepted");
    formData.append("request_id", InfluencerDetailData?.request_id);
    formData.append("file", contractFile); 

    try {
      const res = await axiosMain.put("/api/v1/accept-contract", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Contract uploaded successfully.");
      setShowUploadModal(false);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    }
  };

  const acceptRej = (influencer, action) => {
    console.log(influencer.request_id);

    const payload = {
      request_id: influencer.request_id,
      action: action,
      campaign_id: influencer.campaign_id,
    };

    axiosMain
      .post("/api/v1/accept-request", payload)
      .then((response) => {
        console.log("Response from accept-request:", response.data);

        // Call the second API to send a message
        const chatPayload = {
          conversationId: "new", // Use 'new' or your dynamic ID as required
          senderId: influencer.influencer_id, // Assuming influencer_id is the sender
          receiverId: influencer.brand_id,
          message: influencer.message
            ? influencer.message
            : "Your request has been accepted!", // Customize the message as needed
        };

        axiosMain
          .post("/api/chat/message", chatPayload)
          .then((chatResponse) => {
            console.log("Response from chat message:", chatResponse.data);
          })
          .catch((chatError) => {
            console.error("Error sending chat message:", chatError);
          });

      })
      .catch((error) => {
        console.error("Error in accept-request:", error);
      });

    
  };

  const sendConcern = () => {
    const chatPayload = {
      conversationId: InfluencerDetailData.conversationId,
      senderId: localStorage.getItem("user_id"),
      receiverId: InfluencerDetailData.user_id,
      message: concernMessage, // include the concern message
    };

    axiosMain
      .post("/api/chat/message", chatPayload)
      .then((chatResponse) => {
        console.log("Response from chat message:", chatResponse.data);
        setConcernMessage(""); // optionally clear the textarea after sending
      })
      .catch((chatError) => {
        console.error("Error sending chat message:", chatError);
      });
  };

  const BackNavigate = () => {
    const fromPath = localStorage.getItem("dashboardpath");
    if (fromPath) {
      navigate("/dashboard-influencer");
      localStorage.removeItem("Brand_id");
    } else {
      navigate("/influencer-home");
      localStorage.removeItem("Brand_id");
    }
  };
  return (
    <>
      <button
        // onClick={() => navigate("/influencer-home")}
        onClick={BackNavigate}
        // onClick={() => navigate(-1)}
        className="navback-button mb-3"
      >
        <img src={BackVector} alt="back" className="back-vactor" />
        Back
      </button>
      <div className="container-detail">
        {/* Show message if request is rejected */}
        {InfluencerDetailData?.request_status === "Request Rejected" && (
          <Box
            sx={{
              bgcolor: " rgba(247, 215, 216, 0.5)",
              borderRadius: "8px",
              padding: "8px 24px",
              marginBottom: "10px",
            }}
          >
            <Typography color=" rgba(255, 0, 0, 1)">
              Your Collaborate Request Has been Rejected.
            </Typography>
          </Box>
        )}
        <div className="card-detail">
          <div className="campaign-step-card-wrapper">
            <div
              style={{
                background: "#fff",
                padding: "24px",
                borderRadius: "12px",
                border: "1px solid rgba(238, 238, 238, 1)",
              }}
            >
         

              {InfluencerDetailData?.creator_user_photo ? (
                <div className="mb-4 w-100 position-relative">
                  {/* Influencer Image */}
                  <img
                    src={InfluencerDetailData?.campaign_poster}
                    alt="campign Poster"
                    className="img-fluid rounded"
                    style={{
                      maxHeight: "250px",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />

                  {/* Download Icon (Top-Right) */}
                  <div
                    className="position-absolute top-0 end-0 m-3 bg-white rounded-circle d-flex justify-content-center align-items-center"
                    style={{
                      width: "48px",
                      height: "48px",
                      cursor: "pointer",
                      boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                    }}
                    onClick={() => handleDownloadPDF()}
                  >
                    <img
                      src={DownloadCampaign}
                      alt="Download Icon"
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                </div>
              ) : (
                <p className="text-muted">No profile image available</p>
              )}
              <div className="text-white d-flex justify-content-between align-items-center flex-wrap">
                <h5 className="mb-1 d-flex flex-wrap align-items-center gap-2 mb-0">
                  <span className="text-black">
                    {InfluencerDetailData?.campaign_title}
                  </span>
                  <span className="text-muted small">
                    (
                    {InfluencerDetailData?.start_date
                      ? dayjs(InfluencerDetailData.start_date).format(
                          "DD/MM/YYYY"
                        )
                      : "Start date not set"}{" "}
                    -{" "}
                    {InfluencerDetailData?.end_date
                      ? dayjs(InfluencerDetailData.end_date).format(
                          "DD/MM/YYYY"
                        )
                      : "End date not set"}
                    )
                  </span>
                </h5>

                <button
                  onClick={viewBrandProfile}
                  className="view-brand-profile"
                >
                  View Brand's Profile
                  <GoArrowUpRight size={20} style={{ marginLeft: "8px" }} />
                </button>
              </div>

              <div className="title-name dates d-flex flex-column mt-3 flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
                {/* Left side: Overview and campaign title */}
                <div className="mb-3 mb-md-0">
                  <div className="d-flex flex-column fw-medium">
                    Product{" "}
                    <span className="mb-0 text-muted objectives-content">
                      {InfluencerDetailData?.campaign_title}
                    </span>
                  </div>
                </div>

                {/* Right side: Launch date */}
                <div>
                  <h2 className=" d-flex flex-column text-muted fs-6 fw-medium">
                    Launch Date{" "}
                    <span className="launch-date">
                      {InfluencerDetailData?.launch_date
                        ? dayjs
                            .utc(InfluencerDetailData.launch_date)
                            .format("DD/MM/YYYY")
                        : "N/A"}
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            {/* overview */}

            <div className="campaign-step-card-wrapper mt-3">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  border: "1px solid rgba(238, 238, 238, 1)",
                }}
              >
                <h5 className="mb-3 fw-semibold Goals-objectives">Goals</h5>

                <div className="row g-4 align-items-stretch">
                  <div className="col-md-12 d-flex">
                    <div className="d-flex flex-column w-100">
                      <p className="mb-1 primary-objects fw-semibold">
                        Primary Objective
                      </p>
                      <p className="mb-0 objectives-content">
                        {InfluencerDetailData?.campaign_primary_objective ||
                          "—"}
                      </p>
                    </div>
                  </div>

                  <div className="col-md-12 d-flex">
                    <div className="d-flex flex-column w-100">
                      <p className="mb-1 primary-objects fw-semibold">
                        Secondary Objective
                      </p>
                      <p className="mb-0 objectives-content">
                        {InfluencerDetailData?.campaign_secondary_objective ||
                          "—"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* description */}
            <div className="campaign-step-card-wrapper mt-3">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  border: "1px solid rgba(238, 238, 238, 1)",
                }}
              >
                <div className="campaign-description">
                  <h5 className="section-title">Campaign Description</h5>

                  <div className="section">
                    <div
                      className="phase-title mt-2 mb-3"
                      dangerouslySetInnerHTML={{
                        __html: InfluencerDetailData?.description || "N/A",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="campaign-step-card-wrapper mt-3">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  border: "1px solid rgba(238, 238, 238, 1)",
                }}
              >
                <div className="payment-compensation">
                  <h5 className="section-title">Payment and Compensation</h5>
                  <ul className="mt-2">
                    <li>
                      <strong>Product Exclusivity&nbsp;:&nbsp;</strong>
                      {InfluencerDetailData?.budget}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="campaign-step-card-wrapper mt-3">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  border: "1px solid rgba(238, 238, 238, 1)",
                }}
              >
                <div className="info-section mb-0">
                  {/* <h2 className="OverViewTitle"></h2> */}
                  <h5 className="section-title">Audience Targeting Overview</h5>

                  <ul className="AudienceOverView mt-3">
                    <div className="row">
                      <li className="d-flex flex-column col-6">
                        <span className="text-black">State</span>
                        <div className="chipdesign">
                          {Array.isArray(InfluencerDetailData?.state) &&
                          InfluencerDetailData.state.length > 0 ? (
                            <>
                              {InfluencerDetailData.state
                                .slice(0, 3)
                                .map((state) => {
                                  const stateName =
                                    statesData.find((s) => s.iso2 === state)
                                      ?.state || state;
                                  return (
                                    <Tooltip
                                      title={stateName}
                                      arrow
                                      key={state}
                                    >
                                      <Chip
                                        label={stateName}
                                        sx={{ width: "100px", margin: "2px" }}
                                        style={{
                                          fontSize: "12px",
                                          color: "#6B4750B2",
                                          backgroundColor:
                                            "rgba(221, 225, 230, 0.4)",
                                          fontFamily: "Poppins, sans-serif",
                                          // border: "1px solid black",
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                })}
                              {InfluencerDetailData.state.length > 3 && (
                                <Tooltip
                                  arrow
                                  title={InfluencerDetailData.state
                                    .slice(3)
                                    .map(
                                      (state) =>
                                        statesData.find((s) => s.iso2 === state)
                                          ?.state || state
                                    )
                                    .join(", ")}
                                >
                                  <Chip
                                    label={`+ ${
                                      InfluencerDetailData.state.length - 3
                                    }`}
                                    style={{
                                      fontSize: "11px",
                                      fontFamily: "Poppins, sans-serif",
                                      width: "auto",
                                      cursor: "pointer",
                                      margin: "2px",
                                      backgroundColor:
                                        "rgba(221, 225, 230, 0.4)",
                                      color: "#6B4750B2",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </>
                          ) : InfluencerDetailData?.state ? (
                            <Tooltip
                              title={
                                statesData.find(
                                  (s) => s.iso2 === InfluencerDetailData.state
                                )?.state || InfluencerDetailData.state
                              }
                              arrow
                            >
                              <Chip
                                label={
                                  statesData.find(
                                    (s) => s.iso2 === InfluencerDetailData.state
                                  )?.state || InfluencerDetailData.state
                                }
                                sx={{ width: "100px", margin: "2px" }}
                                style={{
                                  fontSize: "12px",
                                  color: "#6B4750B2",
                                  backgroundColor: "transparent",
                                  fontFamily: "Poppins, sans-serif",
                                  border: "1px solid black",
                                }}
                              />
                            </Tooltip>
                          ) : (
                            <span>None</span>
                          )}
                        </div>
                      </li>

                      <li className="d-flex flex-column col-6">
                        <span className="text-black">City</span>
                        <div className="chipdesign">
                          {Array.isArray(InfluencerDetailData?.city) &&
                          InfluencerDetailData.city.length > 0 ? (
                            <>
                              {InfluencerDetailData.city
                                .slice(0, 3)
                                .map((city, index) => (
                                  <Tooltip title={city} arrow key={index}>
                                    <Chip
                                      label={
                                        city === "panIndia" ? "PanIndia" : city
                                      }
                                      sx={{ width: "100px", margin: "2px" }}
                                      style={{
                                        fontSize: "12px",
                                        color: "#6B4750B2",
                                        backgroundColor:
                                          "rgba(221, 225, 230, 0.4)",
                                        fontFamily: "Poppins, sans-serif",
                                        // border: "1px solid black",
                                      }}
                                    />
                                  </Tooltip>
                                ))}
                              {InfluencerDetailData.city.length > 3 && (
                                <Tooltip
                                  title={
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {InfluencerDetailData.city
                                        .slice(3)
                                        .map((city, index) => (
                                          <div
                                            key={index}
                                            style={{
                                              border: "1px solid #ccc",
                                              borderRadius: "8px",
                                              padding: "4px 8px",
                                              marginBottom: "4px",
                                              fontSize: "12px",
                                              backgroundColor: "#fff",
                                              color: "#6B4750B2",
                                              fontFamily: "Poppins, sans-serif",
                                              maxWidth: "150px",
                                              wordBreak: "break-word",
                                            }}
                                          >
                                            {city === "panIndia"
                                              ? "PanIndia"
                                              : city}
                                          </div>
                                        ))}
                                    </div>
                                  }
                                  arrow
                                >
                                  <Chip
                                    label={`+ ${
                                      InfluencerDetailData.city.length - 3
                                    }`}
                                    style={{
                                      fontSize: "11px",
                                      fontFamily: "Poppins, sans-serif",
                                      width: "auto",
                                      cursor: "pointer",
                                      margin: "2px",
                                      backgroundColor:
                                        "rgba(221, 225, 230, 0.4)",
                                      color: "#6B4750B2",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </>
                          ) : InfluencerDetailData?.city ? (
                            <Tooltip title={InfluencerDetailData.city} arrow>
                              <Chip
                                label={
                                  InfluencerDetailData.city === "panIndia"
                                    ? "PanIndia"
                                    : InfluencerDetailData.city
                                }
                                sx={{ width: "100px", margin: "2px" }}
                                style={{
                                  fontSize: "12px",
                                  color: "#6B4750B2",
                                  backgroundColor: "transparent",
                                  fontFamily: "Poppins, sans-serif",
                                  border: "1px solid black",
                                }}
                              />
                            </Tooltip>
                          ) : (
                            <span>None</span>
                          )}
                        </div>
                      </li>
                    </div>

                    <div className="row">
                      <li className="d-flex flex-column col-6">
                        <span className="text-black">Gender</span>
                        <div className="chipdesign">
                          {Array.isArray(InfluencerDetailData?.gender) ? (
                            InfluencerDetailData.gender.length > 0 ? (
                              <>
                                {InfluencerDetailData.gender
                                  .slice(0, 3)
                                  .map((gender, index) => (
                                    <Tooltip title={gender} arrow key={index}>
                                      <Chip
                                        label={gender}
                                        sx={{ width: "100px", margin: "2px" }}
                                        style={{
                                          fontSize: "12px",
                                          color: "#6B4750B2",
                                          backgroundColor:
                                            "rgba(221, 225, 230, 0.4)",
                                          fontFamily: "Poppins, sans-serif",
                                          // border: "1px solid black",
                                        }}
                                      />
                                    </Tooltip>
                                  ))}
                                {InfluencerDetailData.gender.length > 3 && (
                                  <Tooltip
                                    title={InfluencerDetailData.gender
                                      .slice(3)
                                      .join(", ")}
                                    arrow
                                  >
                                    <Chip
                                      label={`+ ${
                                        InfluencerDetailData.gender.length - 3
                                      }`}
                                      style={{
                                        fontSize: "11px",
                                        fontFamily: "Poppins, sans-serif",
                                        width: "auto",
                                        cursor: "pointer",
                                        margin: "2px",
                                        backgroundColor:
                                          "rgba(221, 225, 230, 0.4)",
                                        color: "#6B4750B2",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </>
                            ) : (
                              <span>None</span>
                            )
                          ) : InfluencerDetailData?.gender ? (
                            <Tooltip title={InfluencerDetailData.gender} arrow>
                              <Chip
                                label={InfluencerDetailData.gender}
                                sx={{ width: "100px", margin: "2px" }}
                                style={{
                                  fontSize: "12px",
                                  color: "#6B4750B2",
                                  backgroundColor: "rgba(221, 225, 230, 0.4)",
                                  fontFamily: "Poppins, sans-serif",
                                  // border: "1px solid black",
                                }}
                              />
                            </Tooltip>
                          ) : (
                            <span>None</span>
                          )}
                        </div>
                      </li>

                      <li className="d-flex flex-column col-6">
                        <span className="text-black">Language</span>
                        <div className="chipdesign">
                          {Array.isArray(InfluencerDetailData?.language) &&
                          InfluencerDetailData.language.length > 0 ? (
                            <>
                              {InfluencerDetailData.language
                                .slice(0, 3)
                                .map((lang, index) => (
                                  <Tooltip title={lang.name} arrow key={index}>
                                    <Chip
                                      label={lang.short_name}
                                      sx={{ width: "100px", margin: "2px" }}
                                      style={{
                                        fontSize: "12px",
                                        color: "#6B4750B2",
                                        backgroundColor:
                                          "rgba(221, 225, 230, 0.4)",

                                        fontFamily: "Poppins, sans-serif",
                                        // border: "1px solid black",
                                      }}
                                    />
                                  </Tooltip>
                                ))}
                              {InfluencerDetailData.language.length > 3 && (
                                <Tooltip
                                  title={InfluencerDetailData.language
                                    .slice(3)
                                    .map((lang) => lang.name)
                                    .join(", ")}
                                  arrow
                                >
                                  <Chip
                                    label={`+ ${
                                      InfluencerDetailData.language.length - 3
                                    }`}
                                    style={{
                                      fontSize: "11px",
                                      fontFamily: "Poppins, sans-serif",
                                      width: "auto",
                                      cursor: "pointer",
                                      margin: "2px",
                                      backgroundColor:
                                        "rgba(221, 225, 230, 0.4)",
                                      color: "#6B4750B2",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </>
                          ) : InfluencerDetailData?.language ? (
                            <Tooltip
                              title={InfluencerDetailData.language.name}
                              arrow
                            >
                              <Chip
                                label={InfluencerDetailData.language.short_name}
                                sx={{ width: "100px", margin: "2px" }}
                                style={{
                                  fontSize: "12px",
                                  color: "#6B4750B2",
                                  backgroundColor: "transparent",
                                  fontFamily: "Poppins, sans-serif",
                                  border: "1px solid black",
                                }}
                              />
                            </Tooltip>
                          ) : (
                            <span>None</span>
                          )}
                        </div>
                      </li>
                    </div>

                    <li className="d-fex">
                      <span className="text-black">Age Group - </span>

                      <div className="chipdesign">
                        {Array.isArray(InfluencerDetailData?.age_group) &&
                        InfluencerDetailData?.age_group?.length > 0 ? (
                          <>
                            {InfluencerDetailData?.age_group
                              ?.slice(0, 3)
                              ?.map((group, index) => (
                                <Tooltip title={group} arrow key={index}>
                                  <Chip
                                    label={group}
                                    sx={{ width: "100px", margin: "2px" }}
                                    style={{
                                      fontSize: "12px",
                                      color: "#6B4750B2",
                                      backgroundColor:
                                        "rgba(221, 225, 230, 0.4)",
                                      fontFamily: "Poppins, sans-serif",
                                      // border: "1px solid black",
                                    }}
                                  />
                                </Tooltip>
                              ))}

                            {InfluencerDetailData?.age_group?.length > 3 && (
                              <Tooltip
                                title={InfluencerDetailData?.age_group
                                  ?.slice(3)
                                  ?.join(", ")}
                                arrow
                              >
                                <Chip
                                  label={`+ ${
                                    InfluencerDetailData?.age_group?.length - 3
                                  }`}
                                  style={{
                                    fontSize: "11px",
                                    fontFamily: "Poppins, sans-serif",
                                    width: "auto",
                                    cursor: "pointer",
                                    margin: "2px",
                                    backgroundColor: "rgba(221, 225, 230, 0.4)",
                                    color: "#6B4750B2",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </>
                        ) : typeof InfluencerDetailData?.age_group ===
                            "string" &&
                          InfluencerDetailData.age_group !== "" ? (
                          <Tooltip title={InfluencerDetailData.age_group} arrow>
                            <Chip
                              label={InfluencerDetailData.age_group}
                              sx={{ width: "100px", margin: "2px" }}
                              style={{
                                fontSize: "12px",
                                color: "#6B4750B2",
                                backgroundColor: "rgba(221, 225, 230, 0.4)",
                                fontFamily: "Poppins, sans-serif",
                                // border: "1px solid black",
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <span>None</span>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <section className="deliverables-section">
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  border: "1px solid rgba(238, 238, 238, 1)",
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <h5 className="section-title">Campaign Deliverables</h5>

                <div className="info-row">
                  <span className="info-value-detail" style={{ width: "100%" }}>
                    {(() => {
                      let timeLine = [];

                      try {
                        const rawTimeline = InfluencerDetailData?.timeline;
                        if (rawTimeline) {
                          if (typeof rawTimeline === "string") {
                            timeLine = JSON.parse(rawTimeline);
                          } else if (Array.isArray(rawTimeline)) {
                            timeLine = rawTimeline;
                          }
                        }
                      } catch (e) {
                        console.error("Error parsing timeline:", e);
                      }

                      return timeLine.length > 0 ? (
                        <div
                          className="container-fluid mt-4"
                          style={{ width: "100%" }}
                        >
                          <div className="table-responsive">
                            <table className="table campign-detail-deliverable table-bordered text-center align-middle deliverable-table">
                              <thead className="table-light">
                                <tr>
                                  <th
                                    rowSpan={2}
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    Tools
                                  </th>
                                  <th
                                    rowSpan={2}
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    Deliverables
                                  </th>
                                  {timeLine.map((_, i) => (
                                    <th key={`week-${i}`}>Week {i + 1}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {Object.entries(timeLine[0]).map(
                                  ([platform, deliverables]) => (
                                    <>
                                      {Object.keys(deliverables).map(
                                        (deliverable, i) => (
                                          <tr
                                            key={`${platform}-${deliverable}`}
                                          >
                                            {i === 0 && (
                                              <td
                                                rowSpan={
                                                  Object.keys(deliverables)
                                                    .length
                                                }
                                                className="fw-semibold"
                                              >
                                                {platform}
                                              </td>
                                            )}
                                            <td>
                                              {formatDeliverableName(
                                                deliverable
                                              )}
                                            </td>
                                            {timeLine.map((week, wIdx) => (
                                              <td key={wIdx}>
                                                {week[platform]?.[deliverable] >
                                                0
                                                  ? week[platform][deliverable]
                                                  : 0}
                                              </td>
                                            ))}
                                          </tr>
                                        )
                                      )}
                                    </>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ) : (
                        <span>No timeline available</span>
                      );
                    })()}
                  </span>
                </div>
              </div>
              {InfluencerDetailData?.contract_status == "Pending" && (
                <div className="ContractBtn">
                  <button
                    className="LightBtn"
                    onClick={() => setShowUploadModal(true)}
                  >
                    Upload Contract
                  </button>
                  <button
                    className="DarkBtn"
                    onClick={() => openPriviewModal()}
                  >
                    Preview Contract
                  </button>
                </div>
              )}

              {InfluencerDetailData?.request_status == "Request Received" && (
                <div className="ContractBtn">
                  <button
                    className="LightBtn Red"
                    onClick={() => acceptRej(InfluencerDetailData, "Rejected")}
                  >
                    Reject Request
                  </button>
                  <button
                    className="DarkBtn"
                    onClick={() => acceptRej(InfluencerDetailData, "Accepted")}
                  >
                    Accept Request
                  </button>
                </div>
              )}

              {InfluencerDetailData?.request_status == "Request Accepted" && (
                <div className="ContractBtn">
                  <button className="LightBtn Red">Reject Request</button>
                </div>
              )}
            </section>

            <ThemeProvider theme={theme}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"end"}
              >
                <Box display={"flex"} alignItems={"center"} gap={2}>
                  {/* Show 'Unsend' button if request is sent */}

                  {/* Show 'Collaborate' button only if status is NOT Sent, Accepted, or Rejected */}
                  {InfluencerDetailData?.request_status == null && (
                    <Button
                      variant="contained"
                      sx={{ width: "200px" }}
                      onClick={() => setIsModalOpen(true)}
                    >
                      <FaLink size={20} style={{ marginRight: "8px" }} />
                      Collaborate
                    </Button>
                  )}
                </Box>
              </Box>
            </ThemeProvider>
          </div>
          <CollaborationModal
            open={isModalOpen}
            setOpen={setIsModalOpen}
            InfluencerDetailData={InfluencerDetailData}
            fetchCampaign={fetchCampaign}
            sender_user_id={localStorage.getItem("user_id")}
            receiver_user_id={InfluencerDetailData?.user_id}
            campaignName={InfluencerDetailData?.campaign_title}
          />
        </div>
      </div>

      {priviewContract && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
          }}
          onClick={closePriviewModal}
        >
          <div
            className="modal-content"
            style={{
              background: "#fff",
              padding: "20px",
              margin: "50px auto",
              width: "80%",
              maxWidth: "800px",
              borderRadius: "8px",
              position: "relative",
              height: "90vh",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Preview Contract</h5>
              <button
                onClick={closePriviewModal}
                className="btn btn-sm btn-outline-secondary"
              >
                ✕
              </button>
            </div>

            <iframe
              src={`https://docs.google.com/gview?url=${encodeURIComponent(
                InfluencerDetailData?.contract_link
              )}&embedded=true`}
              width="100%"
              height="600px"
              frameBorder="0"
            />

            <textarea
              className="form-control mt-3"
              placeholder="Add Any Concern Or Question Regarding Contract (Optional)"
              rows="3"
              value={concernMessage}
              onChange={(e) => setConcernMessage(e.target.value)}
            />

            <div className="d-flex justify-content-between mt-3">
              <button className="btn btn-outline-danger">
                Reject Contract
              </button>
              <div>
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => sendConcern()}
                >
                  Send Concerns
                </button>
                <a
                  href={InfluencerDetailData?.contract_link}
                  download="Contract.pdf"
                  className="btn btn-success"
                >
                  Download Contract
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUploadModal && (
        <div className="upload-modal-overlay">
          <div className="upload-modal-content">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="modal-title fw-bold">Upload Contract</h4>
              <button
                className="btn-close"
                onClick={() => setShowUploadModal(false)}
              />
            </div>

            <div className="upload-drop-box">
              <div className=" text-center">
                <i
                  className="bi bi-cloud-arrow-up"
                  style={{ fontSize: "32px", color: "#6c757d" }}
                />
                <p className="mb-1 mt-2">
                  <strong>Drag your file(s)</strong> or{" "}
                  <span className="text-success" style={{ cursor: "pointer" }}>
                    browse
                  </span>
                </p>
                <p className="text-muted small">
                  Please sign the contract provided by the brand and upload the
                  signed PDF.
                </p>
              </div>
              <input
                type="file"
                accept="application/pdf"
                className="upload-input"
                onChange={(e) => {
                  const selectedFile = e.target.files[0];
                  if (selectedFile) {
                    setContractFile(selectedFile);
                  }
                }}
              />
            </div>

            <div className="d-flex mt-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="termsCheck"
              />
              &nbsp;&nbsp;
              <label className="form-check-label" htmlFor="termsCheck">
                By uploading the contract, you acknowledge and accept the
                brand’s contractual terms.
              </label>
            </div>

            <div className="ContractBtn d-flex justify-content-end mt-4">
              <button className="DarkBtn" onClick={handleUpload}>
                Upload Contract
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InfluencerDetail;
